import { render, staticRenderFns } from "./microsites.vue?vue&type=template&id=669bcdaa&"
import script from "./microsites.vue?vue&type=script&lang=js&"
export * from "./microsites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports